import * as React from "react";
import { UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { NeighborhoodDescriptionProps, NeighborhoodCardContentProps } from "../typings";
import { AggregateRating } from "components/shared/Rating/AggregateRating";
import { UitkHeading, UitkText } from "uitk-react-text";

export const NeighborhoodCardHeader = (props: NeighborhoodCardContentProps) => {
  const { title, subTitle, averageRating, totalRatings, context } = props;

  return (
    <>
      <section>
        {Boolean(title) && (
          <UitkHeading level={3} size={500}>
            {title}
          </UitkHeading>
        )}
        {Boolean(subTitle) && <UitkText size={200}>{subTitle}</UitkText>}
      </section>
      {Boolean(averageRating) && (
        <section className="all-t-margin-four">
          <AggregateRating
            rating={averageRating}
            reviewCount={totalRatings}
            context={context}
            localizationKey="destinationNeighborhood"
            withSuperlative={true}
          />
        </section>
      )}
    </>
  );
};

export const NeighborhoodDescription = (props: NeighborhoodDescriptionProps) => {
  return <div className="uitk-type-300" dangerouslySetInnerHTML={{ __html: `<p> ${props.description} </p>` }} />;
};

export const DesktopCardContent = (props: NeighborhoodCardContentProps) => {
  return (
    <div className="uitk-card-content">
      <section className="all-x-padding-three all-t-padding-three">
        <NeighborhoodCardHeader
          title={props.title}
          subTitle={props.subTitle}
          averageRating={props.averageRating}
          totalRatings={props.totalRatings}
          context={props.context}
        />
      </section>
      <section className="all-x-padding-three all-y-padding-two">
        <NeighborhoodDescription description={props.description} />
      </section>
    </div>
  );
};

export const MobileCardContent = (props: NeighborhoodCardContentProps & { subTitle?: React.ReactNode }) => {
  return (
    <UitkCardContent>
      <UitkCardTextSegment className="uitk-flex uitk-flex-align-items-center">
        <NeighborhoodCardHeader title={props.title} subTitle={props.subTitle} />
      </UitkCardTextSegment>
    </UitkCardContent>
  );
};
